$( ->
  # SETTINGS > LOCATION > NEW/EDIT PAGES

  ## Hides zipcode on load whenever the location's country is the United Arab Emirates

  if $('#location_country').val() == 'AE'
    $('#location_zip_input').hide()

  ## Hides zipcode on country change to the United Arab Emirates

  $('#location_country').on 'change', ->
    if $(this).val() == 'AE'
      $('#location_zip_input').hide()
    else
      $('#location_zip_input').show()
)


